<template>
  <div class="wrapper">
    <transition name="fade">
      <starImage v-if="step === 0"/>
    </transition>
    <Claim v-if="step === 0" />
  <buttonStart v-if="step === 1" v-animate-css.click="'tada'"/>
    <searchInput
    :keyValue="api_key" v-model="searchValue" @input="handleInput"
    :dark="step === 1" />
        <div class="container">
          <div class="img">
            <p v-html="desc"/>
              <a :href="result">
                <img :src="result" class="img-thumbnail" :key="1223"/>
              </a>
          </div>
        </div>
  </div>
</template>

<script>
import Claim from '../components/Claim.vue';
import searchInput from '../components/searchInput.vue';
import starImage from '../components/starImage.vue';
import buttonStart from '../components/buttonStart.vue';


const axios = require('axios');
const debounce = require('lodash.debounce');


export default
{
  name: 'Search',
  components: {
    starImage, Claim, searchInput, buttonStart,
  },
  data() {
    return {
      loading: false,
      step: 0,
      searchValue: '',
      result: '',
      desc: '',
      animationObject: {
        classes: 'tada',
        delay: 500,
        duration: 1000,
      },
    };
  },
  methods: {
    handleInput: debounce(function handle() {
      this.loading = true;
      axios.get('https://api.nasa.gov/planetary/apod?', {
        params: {
          date: this.searchValue,
          api_key: 'JcJ60HqxjGiYm3YUc9471sFH2FxVgdpcTIJo5hIq',
          hd: true,
        },

      })
        .then((response) => {
          this.result = response.data.hdurl;
          this.desc = response.data.explanation;
          this.loading = false;
          this.step = 1;
        });
    }, 200),
  },
};

</script>

<style lang="scss" scoped>
.wrapper{
  display: flex;
  margin: 0;
  padding: 0px;
  width: 100%;
  // align-items: center;
  flex-direction: column;
}
a, img{
  background: none;
  border: none;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
